import React from "react";

// Styles
import "./Loader.scss";

const Loader = ({ imageSrc = "/loading.gif", alt = "" }) => {
  return (
    <div className="loader">
      <img src={imageSrc} alt={alt} />
    </div>
  );
};

export default Loader;
